import { LOAN_TYPES } from "../const/products";
var isLoan = function (productType) {
    return LOAN_TYPES.includes(productType);
};
export default isLoan;
//# sourceMappingURL=isLoan.js.map